import { Popover as PopoverPrimitive } from "@kobalte/core";
import { type JSX, splitProps } from "solid-js";
import { cn } from "@mealplan/shared";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;

export function PopoverContent(
  props: PopoverPrimitive.PopoverContentProps & { class?: string; children?: JSX.Element },
) {
  const [local, others] = splitProps(props, ["class", "children"]);
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        class={cn(
          // z-[220]: ABOVE the Dialog (overlay z-[200], content z-[210]).
          // With z-50, a Popover nested in a dialog would sit BELOW the modal
          // and its controls would be unclickable (CC-21). Select was already at
          // z-[220]; we align Popover using the same criterion.
          "z-[220] w-72 rounded-md border border-border bg-popover p-4 text-popover-foreground shadow-md outline-none animate-in fade-in zoom-in-95 duration-200",
          local.class,
        )}
        {...others}
      >
        {local.children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
}
